// ============================================================
//  MINI CART - HYBRID FIX (Old structure + new fixes)
// ============================================================

class miniCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    
    this.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      
      var line = $(this).closest('.minicart-item').data('line');
      
      // Use jQuery post instead of fetch
      jQuery.post('/cart/change.js', {
        quantity: 0,
        line: line
      }, function(cart) {
        document.querySelector('mini-cart').update();
      }).fail(function(e) {
        console.error(e);
      });
    });
  }
}
customElements.define('mini-cart-remove-button', miniCartRemoveButton);


class miniCart extends HTMLElement {
  constructor() {
    super();
    this.display();
    document.querySelector('mini-cart').updateRow();
  }

  update(){
    var self = this;
    jQuery.getJSON('/cart.js', function(cart) {
      var minicart = '';
      var cart_items = cart.items;
      
      if (cart_items.length === 0) {
        $("#minicart .list-mimicart").html('<p style="text-align:center;padding:30px;color:#999;">Your cart is empty</p>');
      } else {
        $(cart_items).each(function(i, item) {
          var item_price = Shopify.formatMoney(item.price, theme.moneyFormat);
          var line = i + 1;
          
          minicart += '<div class="minicart-item" data-line="' + line + '">';
          if (item.image) {
            minicart += '<a class="image-product" href="' + item.url + '"><img width="auto" height="auto" class="mimicart-item__image" src="' + item.image + '" alt="' + item.product_title + '"></a>';
          }
          minicart += '<div class="minicart-price">';
          minicart += '<a href="' + item.url + '" class="mimicart-item__name">' + item.product_title + '</a>';
          minicart += '<span class="price price--end">' + item_price + '</span>';
          minicart += '<mini-cart-remove-button><span class="mimicart-item__remove" aria-label="Remove">✕</span></mini-cart-remove-button>';
          minicart += '<quantity-input class="quantity">';
          minicart += '<button class="quantity__button no-js-hidden" name="minus" type="button">−</button>';
          minicart += '<input class="quantity__input" type="number" name="updates[]" value="' + item.quantity + '" min="0" id="Quantity-' + line + '" data-index="' + line + '">';
          minicart += '<button class="quantity__button no-js-hidden" name="plus" type="button">+</button>';
          minicart += '</quantity-input>';
          minicart += '</div></div>';
        });

        $("#minicart .list-mimicart").html(minicart);
      }
      
      var total_price = Shopify.formatMoney(cart.total_price, theme.moneyFormat);    
      $("#minicart span.total_price").html(total_price);
      $(".header-cart .header__icon > .totals .total_price").html(total_price);
      $(".cart-count-bubble span:first-child").html(cart.item_count);
      
      if (typeof updateCurrencies === 'function') {
        updateCurrencies();
      }
      
      document.querySelector('mini-cart').updateRow();
      
      if (document.querySelector('cart-freeshipping')) {
        document.querySelector('cart-freeshipping').update(cart.total_price);
      }
      
      if (typeof displayCrossSell === 'function') {
        displayCrossSell();
      }
      
      $('#jsUpsell').remove();
      
      // Show/hide empty state
      if (cart.item_count === 0) {
        $('#minicart .totals, #minicart .bottom-minicart, #minicart .free-shipping').hide();
      } else {
        $('#minicart .totals, #minicart .bottom-minicart, #minicart .free-shipping').show();
      }
    }); 
  }
  
  updateRow(){
    var self = this;
    
    $("#minicart").off('change', '.quantity__input');
    $("#minicart").off('click', '.quantity__button');
    
    var timeout = null;
    
    $("#minicart").on('change', '.quantity__input', function() {
      clearTimeout(timeout);
      var quantity = $(this).val();
      var line = $(this).closest('.minicart-item').data('line');
      
      if (quantity <= 0) quantity = 0;
      
      timeout = setTimeout(function() {
        jQuery.post('/cart/change.js', {
          quantity: quantity,
          line: line
        }, function() {
          document.querySelector('mini-cart').update();
        }).fail(function(e) {
          console.error(e);
        });
      }, 300);
    });
    
    $("#minicart").on('click', '.quantity__button', function(e) {
      e.preventDefault();
      var $input = $(this).siblings('.quantity__input');
      var currentQty = parseInt($input.val()) || 1;
      var action = $(this).attr('name');
      var line = $(this).closest('.minicart-item').data('line');
      
      var newQty = action === 'plus' ? currentQty + 1 : currentQty - 1;
      
      if (newQty <= 0) {
        jQuery.post('/cart/change.js', { quantity: 0, line: line }, function() {
          document.querySelector('mini-cart').update();
        });
        return;
      }
      
      $input.val(newQty);
      jQuery.post('/cart/change.js', { quantity: newQty, line: line }, function() {
        document.querySelector('mini-cart').update();
      }).fail(function(e) {
        console.error(e);
      });
    });
  }
  
  display(){
    var self = this;
    
    $("#cart-icon-bubble").off('click');
    $("#cart-icon-bubble").on('click', function(e) {
      e.preventDefault();
      if ($("#minicart").hasClass('active')) {
        self.close();
      } else {
        self.open();
      }
      return false;
    });
    
    $(document).off('click.minicart');
    $(document).on('click.minicart', function(event) { 
      var $target = $(event.target);
      if(!$target.closest('#minicart').length && 
         !$target.closest('#cart-icon-bubble').length && 
         $('#minicart').hasClass('active')) {
        self.close();
      }        
    });
    
    $(document).off('keydown.minicart');
    $(document).on('keydown.minicart', function(e) {
      if (e.key === 'Escape' && $('#minicart').hasClass('active')) {
        self.close();
      }
    });
  }
  
  open() {
    sessionStorage.setItem('mini_cart_referrer', window.location.href);
    this.update();
    $("#minicart").addClass('active');
    $("body").css('overflow', 'hidden');
  }
  
  close() {
    $("#minicart").removeClass('active');
    $("body").css('overflow', '');
  }
}
customElements.define('mini-cart', miniCart);


// ─── OPEN MINI CART WHEN PRODUCT ADDED ───
$(document).on('submit', 'form[action*="/cart/add"]', function() {
  if ($(this).attr('id') === 'cart') return;
  
  sessionStorage.setItem('mini_cart_referrer', window.location.href);
  
  var initialCount = parseInt($(".cart-count-bubble span:first-child").text()) || 0;
  var attempts = 0;
  
  var poll = setInterval(function() {
    attempts++;
    $.getJSON('/cart.js', function(cart) {
      if (cart.item_count > initialCount || attempts >= 30) {
        clearInterval(poll);
        var mc = document.querySelector('mini-cart');
        if (mc) mc.open();
      }
    }).fail(function() {
      if (attempts >= 5) {
        clearInterval(poll);
        setTimeout(function() {
          var mc = document.querySelector('mini-cart');
          if (mc) mc.open();
        }, 1000);
      }
    });
  }, 400);
});


// ─── CONTINUE SHOPPING ───
$(document).on('click', '[data-action="continue-shopping"], .continue-shopping', function(e) {
  e.preventDefault();
  var fallback = $(this).data('fallback') || '/collections/all';
  
  var stored = sessionStorage.getItem('mini_cart_referrer');
  if (stored && stored.indexOf('/cart') === -1 && stored.indexOf('/checkout') === -1) {
    window.location.href = stored;
    return;
  }
  
  if (document.referrer && document.referrer.indexOf(window.location.host) !== -1 && document.referrer.indexOf('/cart') === -1) {
    window.location.href = document.referrer;
    return;
  }
  
  if (window.history.length > 1) {
    window.history.back();
    return;
  }
  
  window.location.href = fallback;
});


// ─── GIFT MESSAGE COUNTER ───
$(document).on('input', 'textarea[name="properties[Message]"]', function() {
  var count = $(this).val().length;
  $(this).closest('div').find('.gift-count').text(count + ' / 200');
});


// ─── UPSELL ADD BUTTONS ───
$(document).on('click', '.upsell-add-btn', function() {
  var variantId = $(this).data('variant-id');
  var button = $(this);
  
  button.text('Adding...').prop('disabled', true);
  
  jQuery.post('/cart/add.js', {
    items: [{ id: variantId, quantity: 1 }]
  }, function() {
    document.querySelector('mini-cart').update();
  }).fail(function(e) {
    console.error(e);
    button.text('+ Add').prop('disabled', false);
  });
});